import Vue from 'vue'
import VueRouter from 'vue-router'
import Store from '../views/Store.vue'
import Detial from '../views/Detail.vue'
import Login from '../views/Login.vue'
import PayLogin from '../views/PayLogin.vue'
import Consume from '../views/Consume.vue'
import Finish from '../views/Finish.vue'
import FinishDetail from '../views/FinishDetail.vue'
import Content from '../views/Content.vue'
import ChangePwd from '../views/ChangePwd.vue'
import ForgetPwd from '../views/ForgetPwd.vue'
import SetPwd from '../views/SetPwd.vue'
import SetPwdStep2 from '../views/SetPwdStep2.vue'
import BindEmail from '../views/BindEmail.vue'
import BindSuccess from '../views/BindSuccess.vue'
import Agreement from '../views/agreement/index.vue'

Vue.use(VueRouter)
const routes = [{
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/paylogin',
        name: 'paylogin',
        component: PayLogin
    },
    {
        path: '/store',
        name: 'store',
        component: Store
    },
    {
        path: '/detail',
        name: 'detail',
        component: Detial
    },
    {
        path: '/consume',
        name: 'consume',
        component: Consume
    },
    {
        path: '/finish',
        name: 'finish',
        component: Finish
    },
    {
        path: '/finishdetail',
        name: 'finishdetail',
        component: FinishDetail
    },
    {
        path: '/content',
        name: 'content',
        component: Content
    },
    {
        path: '/changepwd',
        name: 'changePwd',
        component: ChangePwd
    },
    {
        path: '/forgetpwd',
        name: 'forgetPwd',
        component: ForgetPwd
    },
    {
        path: '/setpwd',
        name: 'setPwd',
        component: SetPwd
    },
    {
        path: '/setpwdstep2',
        name: 'setPwdStep2',
        component: SetPwdStep2
    },
    {
        path: '/bindemail',
        name: 'bindemail',
        component: BindEmail
    },
    {
        path: '/bindsuccess',
        name: 'bindsuccess',
        component: BindSuccess
    },
    {
        path: '/agreement',
        name: 'agreement',
        component:Agreement// () => import(/* webpackChunkName: "agreement" */ '../views/agreement/index.vue')
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router